export const CURRENT_TEAM_ID_RECEIVED = 'CURRENT_TEAM_ID_RECEIVED';

const getCurrentTeamId = () => (
  (dispatch) => {
    if (window.currentTeamId !== null) {
      dispatch({
        type: CURRENT_TEAM_ID_RECEIVED,
        currentTeamId: window.currentTeamId,
      });
    }
  }
);

export default getCurrentTeamId;
